import * as React from "react";

const chevronFirst: React.FC = () => {
    return (
        <svg viewBox="0 0 6 13" xmlns="http://www.w3.org/2000/svg">
            <path d="m3.3 6 5 5 .7-.7L4.7 6 9 1.7 8.3 1l-5 5Zm-2-6h-1v12h1V0Z" fill="#333F48" fillRule="evenodd"/>
        </svg>
    );
};


export default React.memo(chevronFirst);
